const Roles = {
  SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  OWNER: "GROUP_ROLE_OWNER",
  ADMIN: "GROUP_ROLE_ADMIN",
  EDITOR: "ROLE_EDITOR",
  VIEWER: "ROLE_VIEWER",
  OG_USER: "ROLE_OG_USER",
  DEMO_USER: "ROLE_DEMO_USER",
};

const ALL_PLATFORM_ROLES = [
  "ROLE_SUPER_ADMIN",
  "ROLE_OG_USER",
  "ROLE_DEMO_USER",
];

function canAccessAllPlatforms(roles) {
  const list = Array.isArray(roles) ? roles : Object.values(roles ?? {});
  return list.some((r) => ALL_PLATFORM_ROLES.includes(r));
}

function normalizeCaps(rights) {
  return Array.isArray(rights) ? rights : rights?.caps ?? [];
}

function has(caps, cap) {
  return caps.includes(cap);
}

function hasAny(caps, list) {
  return list.some((c) => has(caps, c));
}

function getRoleRights(caps) {
  return {
    edit: hasAny(caps, [Roles.OWNER, Roles.ADMIN, Roles.EDITOR]),
    invite: hasAny(caps, [Roles.OWNER, Roles.ADMIN, Roles.EDITOR]),
    manageRoles: hasAny(caps, [Roles.OWNER, Roles.ADMIN]),
    viewHistory: hasAny(caps, [Roles.OWNER, Roles.ADMIN, Roles.EDITOR, Roles.VIEWER]),
    transfer: has(caps, Roles.OWNER),
    delete: hasAny(caps, [Roles.OWNER, Roles.ADMIN]),
    leave: !has(caps, Roles.OWNER),
  };
}

export { Roles, ALL_PLATFORM_ROLES, canAccessAllPlatforms, normalizeCaps, has, hasAny, getRoleRights };
